import { put, takeLatest, all, select } from 'redux-saga/effects'

import * as actions from '../actions'

import { getSelectedIteration, getIsSelectedIterationCompleted } from '../selectors'

function* onSetSelectedIterationId({ payload: iterationId }) {
  if (iterationId <= 0) {
    return
  }

  const selectedIteration = yield select((state) => getSelectedIteration(state))
  const isSelectedIterationCompleted = yield select((state) => getIsSelectedIterationCompleted(state))

  if (!selectedIteration.isPagesLoaded) {
    yield put(actions.loadExistingIterationPages())
  }

  if (isSelectedIterationCompleted && !selectedIteration.isMetricsLoaded) {
    yield put(actions.getMetricsByIterationId.request(iterationId))
  }

  if (!selectedIteration.isFiltersLoaded) {
    yield put(actions.getFiltersByIterationId.request(iterationId))
  }
}

function* selectIteration() {
  yield all([takeLatest(actions.setSelectedIterationId, onSetSelectedIterationId)])
}

export default selectIteration
